import { Directive, Renderer2, ElementRef, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[sf]'
})
export class SFDirective implements OnInit {

  private labelKey: string;

  @Input()
  set myDirective(key: string) {
    this.labelKey = key;
  }

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  ngOnInit() {
    console.log(this.labelKey);
    // this.renderer.addClass(this.el.nativeElement, 'wild');
    // this.el.nativeElement.
    // this.renderer.appendChild(this.el.nativeElement, 'test');
    const li = this.renderer.createElement('div');
    const text = this.renderer.createText('New li element from renderer');

    this.renderer.appendChild(li, text);
    // const insert: HTMLElement = div.firstChild as HTMLElement;
    const before: HTMLElement = this.el.nativeElement.nextElementSibling;
    const parent: HTMLElement = this.el.nativeElement.parentElement;
  //  if (before) {
       parent.after(li);
   // } else {
   //    parent.appendChild(li);
   // }
  }
}
